import React from 'react'

function Annotations({ children }) {
  return (
    <div className="calculator-annotations">
      {children}
    </div>
  )
}

export default Annotations



// WEBPACK FOOTER //
// ./src/components/Annotations/index.js